import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import VacationRequestDialog from "#vacation/components/vacation-request-dialog/VacationRequestDialog"
import ColaboradorCard from "#vacation/components/VacationColaboradorCard"
import VacationDialogApprove from "#vacation/components/VacationDialogApprove"
import { UseVacationContext, VacationProvider } from "#vacation/contexts/VacationContext"
import { vacationGet } from "#vacation/services/api"
import { Typography } from "@mui/material"
import Box from "@mui/material/Box"
import Skeleton from "@mui/material/Skeleton"
import { ChangeTitle } from "Components/menu/funciones"
import { useMemo } from "react"

export default function VacationBoss() {
	ChangeTitle("Vacaciones")
	return (
		<Box display={"flex"} flexWrap={"wrap"} justifyContent={"left"} gap={"20px"}>
			<VacationProvider>
				<ColaboradoresCards />
				<VacationDialogApprove />
				<VacationRequestDialog />
			</VacationProvider>
		</Box>
	)
}

export function ColaboradoresCards({ boss = true }) {
	const { reload } = UseVacationContext()
	const params = useMemo(() => ({ request_boss: true }), [])
	const { data, loading, error } = useApi(vacationGet, {
		autoFetch: true,
		params,
		reload,
	})
	const vacations = data?.data || []

	if (loading) return <VacationSkeleton />
	if (error) return <div>error</div>

	if (!vacations.length)
		return <ErrorResponse error="No Hay solicitudes de vacaciones" height="80vh" />

	return vacations.map((vacation) => {
		return (
			<Box component={"div"} key={vacation.id}>
				<ColaboradorCard {...vacation} />
			</Box>
		)
	})
}

const VacationSkeleton = () => {
	let skeletons = []
	for (let i = 0; i < 8; i++) {
		skeletons.push(
			<Box component={"div"}>
				<Skeleton sx={{ minWidth: "500px", height: 200 }} />
			</Box>
		)
	}

	return (
		<Box
			display={"inline-flex"}
			flexWrap={"wrap"}
			justifyContent={"flex-start"}
			gap={"20px"}
		>
			{skeletons}
		</Box>
	)
}
